export default __webpack_public_path__ + "static/media/shoeboxCard.005541ef.png";